
import {
  computed, defineComponent, ref, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import Dialog from '@/components/dialog/Dialog.vue';
import { IDialog, useDialog } from '@/hooks/useDialog';

export default defineComponent({
  name: 'Dialogs',
  components: { Dialog },
  setup() {
    const {
      dialogs,
      closeDialogById,
    } = useDialog();

    const hiddenDialogs = ref<Array<IDialog['id']>>([]);

    const hideDialogById = (id: IDialog['id']) => {
      hiddenDialogs.value.push(id);
    };

    const { currentRoute } = useRouter();

    watch(computed(() => (JSON.stringify({
      name: currentRoute.value?.name,
      params: currentRoute.value?.params,
    }))), (oldValue, newValue) => {
      if (oldValue === newValue) {
        return;
      }
      dialogs.value.forEach(({ id, preventCloseOnRouteChange }) => {
        if (!preventCloseOnRouteChange) {
          closeDialogById(id);
        }
      });
    });

    return {
      dialogs,
      closeDialogById,
      hideDialogById,
      hiddenDialogs,
    };
  },
});
